module.exports = __webpack_public_path__ + "static/img/12.cde53929.png";